import onGetDevices from './onGetDevices';
import onGetMoreDevices from './onGetMoreDevices';
import onRegisterDevice from './onRegisterDevice';

export default {
  onGetDevices,
  onGetMoreDevices,
  onRegisterDevice,
};
